/**
 * Converts a string to camelCase.
 *
 * @param {string} str - The input string to be converted.
 * @returns {string} The camelCase version of the input string.
 */
export var convertToCamelCase = function convertToCamelCase(str) {
  // If the input is already camelCase, return it as is
  if (/^[a-z][A-Za-z]*$/.test(str)) {
    return str;
  }

  // Replace underscores with a space
  var stringWithSpaces = str.replace(/_/g, ' ');

  // Capitalize the first letter of each word
  var stringWithCapitalization = stringWithSpaces.replace(/\b\w/g, function (match) {
    return match.toUpperCase();
  });

  // Remove spaces
  var camelCaseString = stringWithCapitalization.replace(/\s+/g, '');

  // Return string with ensurance that the first letter is lowercase
  return camelCaseString.charAt(0).toLowerCase() + camelCaseString.slice(1);
};

/**
 * Converts a string to snake_case.
 * Basing the conversion on the capitalization of strings, and by potential spaces.
 *
 * @param {string} str - The input string to be converted.
 * @returns {string} The snake_case version of the input string.
 */
export var convertToSnakeCase = function convertToSnakeCase(str) {
  // Replace spaces with underscores
  var stringWithUnderscores = str.replace(/\s+/g, '_');

  // Replace uppercase letters with underscore + lowercase
  var snakeCaseString = stringWithUnderscores.replace(/([a-z])([A-Z])/g, function (_, lower, upper) {
    return "".concat(lower, "_").concat(upper.toLowerCase());
  });
  return snakeCaseString.toLowerCase();
};